import { MoneyConnectClientAPI } from "./axios-service-creator";

export const BuySellSwitchAPI = {
  getFundList: params => MoneyConnectClientAPI.get("/funds/funds", { params }),
  getFundById: params => MoneyConnectClientAPI.get("/funds/funds/detail", { params }),
  getAccountList: params => MoneyConnectClientAPI.get("funds/funds/accounts", { params }),
  getUHMF: () => MoneyConnectClientAPI.get("/funds/funds/uhmf"),
  buyFund: payload => MoneyConnectClientAPI.post("/fund-transaction/payment/buy", payload),
  validateBuy: payload => MoneyConnectClientAPI.post("/funds/funds/validate/buy", payload),
  getAmountRule: params => MoneyConnectClientAPI.get("/funds/funds/rules", { params }),
  getRedeemAccount: params => MoneyConnectClientAPI.get("/funds/funds/accounts/receive", { params }),
  getAssetKcus: () => MoneyConnectClientAPI.get("/funds/funds/kcus"),
  sellFund: payload => MoneyConnectClientAPI.post("/fund-transaction/payment/sell", payload),
  validateSell: payload => MoneyConnectClientAPI.post("/funds/funds/validate/sell", payload),
  validateSwitch: payload => MoneyConnectClientAPI.post("/funds/funds/validate/switch", payload),
  fetchFundTransaction: params => MoneyConnectClientAPI.get("/fund-transaction/payment/history", { params }),
  fetchRetrospectiveTransaction: params => MoneyConnectClientAPI.get("/fund-transaction/payment/history/success", { params }),
  fetchAvailableSwitchFunds: params => MoneyConnectClientAPI.get("/funds/funds/switch", { params }),
  switchFund: payload => MoneyConnectClientAPI.post("/fund-transaction/payment/switch", payload),
  cancelFund: payload => MoneyConnectClientAPI.post("/fund-transaction/payment/history/cancel", payload),
  getEmailByUhmfNo: (payload) => MoneyConnectClientAPI.post("/fund-transaction/public/findEmailByUhmfNo", payload),
  sendEmail: (payload) => MoneyConnectClientAPI.post("/fund-transaction/sendEmail/confirmFund", payload),
}
